module.exports = __webpack_public_path__ + "img/左通风.66c0d2f2.png";